module.exports = __webpack_public_path__ + "static/media/image4.1c221de9.jpg";